export function sanitizeInput(input: any) {
  if (typeof input === 'string') {
    // Replace special characters with their HTML entity equivalents
    return input
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/`/g, '&#96;')
  }
  if (typeof input === 'function') {
    return null
  }
  return input
}

export function sanitizeObject(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map((item) => sanitizeObject(item))
  }

  if (typeof obj === 'object' && obj !== null) {
    const sanitizedObj: Record<string, any> = {}

    Object.entries(obj).forEach(([key, value]) => {
      sanitizedObj[key] = sanitizeObject(value)
    })

    return sanitizedObj
  }

  return sanitizeInput(obj)
}

export function sanitizeHeaderString<T extends string>(
  value: string | string[] | null | undefined
): T | undefined {
  if (Array.isArray(value)) {
    return value[0] as T
  }
  return (value as T) ?? undefined
}
